import { CSSObject } from "@mui/material/styles";

export type StylesClasses =
  | "wrapper"
  | "childWrapper"
  | "heading"
  | "container"
  | "row"
  | "input"
  | "selectWrapper"
  | "fileUploadWrapper"
  | "documentSection"
  | "label"
  | "value"
  | "fileLink"
  | "buttonGroup"
  | "actionButtons"
  | "section"
  | "sectionTitle"
  | "gcaTypeTag"
  | "statusBadge";

const defaultStyles: Record<StylesClasses, CSSObject> = {
  wrapper: {
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: 0,
    boxSizing: "border-box",
  },
  childWrapper: {
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto 24px",
    padding: "32px 40px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #d8dde3",
    boxShadow: "0 2px 8px rgba(16, 24, 40, 0.08)",
    boxSizing: "border-box",
    "@media (max-width: 1024px)": {
      padding: "24px 28px",
    },
  },
  heading: {
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: "12px",
    color: "#1f2937",
    textTransform: "capitalize",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "20px 32px",
    width: "100%",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
      gap: "16px",
    },
  },
  row: {
    display: "contents",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  selectWrapper: {
    width: "100%",
  },
  fileUploadWrapper: {
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "12px",
    backgroundColor: "#fafafa",
  },
  documentSection: {
    marginTop: "20px",
    padding: "15px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  label: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#666",
  },
  value: {
    fontSize: "14px",
    color: "#333",
    wordBreak: "break-word",
  },
  fileLink: {
    color: "#1976d2",
    textDecoration: "none",
    cursor: "pointer",
    fontSize: "14px",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    marginTop: "20px",
    flexWrap: "wrap",
  },
  actionButtons: {
    display: "flex",
    gap: "10px",
  },
  section: {
    marginBottom: "30px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "15px",
    color: "#333",
  },
  gcaTypeTag: {
    display: "inline-block",
    backgroundColor: "#1976d2",
    color: "white",
    padding: "6px 12px",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: 600,
    marginBottom: "15px",
  },
  statusBadge: {
    display: "inline-block",
    padding: "6px 12px",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: 600,
  },
};

export default defaultStyles;
